import DatabaseModel from './DatabaseModel.js';

var Property = Object.create(DatabaseModel);

Property.model = 'core/config/property';
Property.modelFront = 'properties';

export default Property;